
export default function (selection, container) {
  var li = selection.node()
    , scrollTop = container.scrollTop
    , offsetHeight = container.offsetHeight
    , rs = li.parentNode.parentNode // resultset for the element we're scrolling to
    , offset = 0

  // Add all previous resultsets into offset
  while (rs.previousSibling) {
    offset += rs.previousSibling.offsetHeight
    rs = rs.previousSibling
  }

  // Add the parent nodes offsetTop from within the resultset, to accomdate for headers
  var header = li.parentNode.previousSibling
  if (header) {
    offset += header.offsetHeight
  }

  // Now we can add the node's offset within its `ul`
  offset += li.offsetTop

  if (offset + li.offsetHeight > scrollTop + offsetHeight) {
    container.scrollTop += (offset + li.offsetHeight) - (scrollTop + offsetHeight)
  } else if (offset < scrollTop) {
    container.scrollTop = offset
  }
}
